import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Debounce from "@saleor/components/Debounce";
import React from "react";

export interface MallSearchInputProps {
  className?: string;
  placeholder: string;
  initialSearch: string;
  onSearchChange: (text: string) => void;
}

const MallSearchInput: React.FC<MallSearchInputProps> = props => {
  const { className, placeholder, initialSearch, onSearchChange } = props;

  const [search, setSearch] = React.useState(initialSearch);
  React.useEffect(() => setSearch(initialSearch), [initialSearch]);

  return (
    <Debounce debounceFn={onSearchChange}>
      {debounceSearchChange => {
        const handleSearchChange = (event: React.ChangeEvent<any>) => {
          const value = event.target.value;
          setSearch(value);
          debounceSearchChange(value);
        };

        return (
          <FormControl
            variant="outlined"
            style={{ width: "100%" }}
            className={className}
          >
            <InputLabel htmlFor="outlined-adornment-search">
              {placeholder}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-search"
              type="text"
              value={search}
              onChange={handleSearchChange}
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        );
      }}
    </Debounce>
  );
};

MallSearchInput.displayName = "MallSearchInput";
export default MallSearchInput;
